import { render } from "./DealRequest.vue?vue&type=template&id=0dd87957&scoped=true"
import script from "./DealRequest.vue?vue&type=script&lang=js"
export * from "./DealRequest.vue?vue&type=script&lang=js"

import "./DealRequest.vue?vue&type=style&index=0&id=0dd87957&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd87957"]])

export default __exports__